<template>
  <div>
    <p>
      Please enter the login code that was sent to you and click Validate login code. 
      <span v-if="!(store.state.guestLogin?.loginUserDetails?.isPaperOtpSent && store.state.guestLogin?.mfaType == 3) && store.state.guestLogin?.loginMfaRequest?.otpEndDateTime">
        The login code is valid until {{ otpEndTime }}.
      </span>
      Do not share this login code with anyone. If you did not receive the login code you can click 'Resend login code' or click 'Previous' to go back and review your contact information. After reviewing the contact information you can click 'Next' to resend the login code or, if applicable, click 'Not my contact info'.
    </p>

    <div class="user-otp">
      <div class="input-otp">
        <label for="loginCode" class="otp-text app-required-indicator __after">Login code</label>
        <input type="text" id="loginCode" name="OneTimePassword" v-model="otp" maxlength="12">
        <p v-if="errorMsg" class="error-msg">
          {{ errorMsg }}
        </p>
        <p class="sr-only" v-if="errorMsg">
          {{ errorMsg }}
        </p>
      </div>
    </div>

    <BaseButtonGroup>
      <button type="button" @click="handleRouting('previous')">Previous</button>
      <CustomButton type="submit" @click="handleRouting('validateOtp')" :disabled="btnDisable">Validate login code</CustomButton>
      <button type="button" class="resend" @click="handleRouting('resendOtp')" :disabled="btnDisable">Resend login code</button>
    </BaseButtonGroup>
    <MailOtpConfirmationModal :showMailOtpModalActive="mailOtpActiveModal" @getMailOtpShowStatus="showMailOtpModal" ref="extendedModal"/>

  </div>
</template>


<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup.vue';
import * as COMMONS from '../../store/_commons';
import MailOtpConfirmationModal from '../../components/appModal/MailOtpConfirmationModal.vue';
import CustomButton from '../CustomButton.vue';

const store = useStore();
const router = useRouter();

// Reactive state 
const otp = ref('');
const count = ref(0);
const errorMsg = ref('');
const mailOtpActiveModal = ref(false);

// Refs for template elements
const extendedModal = ref(null);

// Computed properties 
const otpEndTime = computed(() => {
  const dateVal = store.state.guestLogin?.loginMfaRequest?.otpEndDateTime;
  if (!dateVal) return '';

  const serverDate = new Date(dateVal);
  const offset = new Date(dateVal).getTimezoneOffset() / 60;
  const offsetValue = offset === 4 ? -4 : -5;
  const utcTime = serverDate.getTime() - (serverDate.getTimezoneOffset() * 60000);
  const localDateVal = new Date(utcTime - (3600000 * offsetValue));
  return localDateVal.toLocaleString();
});

const btnDisable = computed(() => store.state.guestLogin?.btnDisable);

const contactInfo = computed(() => store.state.guestLogin?.loginUserDetails);

// Actions
const completeGuestLogin = (payload) => store.dispatch(COMMONS.GUEST_COMPLETE_LOGIN, payload);

// Lifecycle hooks
onMounted(() => {
  window.scroll(0, 0);
  document.body.setAttribute("tabindex", "1");
  document.body.focus();
  document.body.removeAttribute("tabindex");
  document.getElementById("app").scrollTop = 0;
});

onBeforeUnmount(() => {
  store.state.networkResponse = null;
  store.state.guestLogin.btnDisable = false;
});

// Methods 
const handleRouting = async (info) => {
  if (info == 'previous') {
    if (contactInfo.value?.isPaperOtpSent) {
      router.push({ name: 'GuestSignin' });
    } else {
      store.state.guestLogin.mfaStep = 1;
      if (count.value >= 3) {
        router.push({ name: 'GuestSignin' });
      }
    }
  } else if (info == 'validateOtp') {
    errorMsg.value = '';
    if (otp.value != '' && otp.value != null) {
      count.value += 1;
      const payload = {
        verificationCode: otp.value,
        attemptValue: count.value
      };
      await completeGuestLogin(payload);
    } else {
      errorMsg.value = 'Login code is required';
    }
  } else {
    mailOtpActiveModal.value = true;
  }
};

const showMailOtpModal = async (val) => {
  if (val == 'Yes') {
    if (contactInfo.value?.email != '' || contactInfo.value?.phone != '') {
      store.state.guestLogin.mfaStep = 1;
    } else {
      store.state.guestLogin.mfaStep = 3;
    }
  } else {
    mailOtpActiveModal.value = false;
  }
};
</script>


<style lang="scss" scoped>

.user-otp {
  margin-top: 2rem;
  .input-otp {
    margin-bottom: 3rem;
    .otp-text {
      font-size: 24px;
      margin-bottom: 1rem;
    }
  }
}
.resend {
  background-color: #fff;
  color: var(--ri-blue);
}
.error-msg{
  color: var(--ri-red);
}
button {
  margin-bottom: 1.125em;
  &:not(:last-child) {
    margin-right: 1em;
  }
  &.disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
}
</style>